module.exports = __webpack_public_path__ + "static/img/debris.a1410d08.png";